module.exports = __webpack_public_path__ + "static/media/33000135.ad60770e.jpg";